import { useState } from "react";
import { Link } from "react-router-dom";
import ResourceCard from "@/components/base/ResourceCard";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/resources";
import type { CategoryKey } from "@/types/content";
import { getCategoryResources } from "@/utils/content";

export default function HotResources() {
  const [active, setActive] = useState<CategoryKey>("movie");
  const list = [...getCategoryResources(active)].sort((a, b) => b.views - a.views).slice(0, 4);

  return (
    <section aria-label="热门资源推荐" className="mt-12 md:mt-16">
      <SectionHeading
        title="热门资源"
        subtitle="根据访问量统计的高清资源，切换分类查看不同榜单"
        icon="ri-line-chart-line"
      >
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 shrink-0">
          {categories.map((category) => (
            <button
              key={category.key}
              type="button"
              onClick={() => setActive(category.key)}
              className={`px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                active === category.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>
      </SectionHeading>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {list.map((item, index) => (
          <ResourceCard key={item.id} resource={item} rank={index + 1} />
        ))}
      </div>

      <div className="mt-5 flex justify-center">
        <Link
          to={`/category/${active}`}
          className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 cursor-pointer transition-colors whitespace-nowrap"
        >
          查看全部{active === "movie" ? "影视" : active === "anime" ? "动漫" : "音乐"}资源
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}